import React from 'react'

export default function Header() {
  const Book1 = () => {
    alert("Hi! there thanks for visiting, this functionality will be added soon")
  }
  const Book2 = () => {
    alert("Hi! there thanks for visiting, this functionality will be added soon")
  }
  const Book3 = () => {
    alert("Hi! there thanks for visiting, this functionality will be added soon")
  }

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
        <div className="container-fluid">
          <a className="navbar-brand" style={{ color: "black", fontWeight: "bold", marginLeft: "100px", padding: "10px" }} href="#" ><i>WEATHER</i></a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div className="navbar-nav ml-auto" style={{ marginLeft: "auto", marginRight: "100px", padding: "10px" }}>
              <button type="button" style={{ color: "black", fontWeight: "bold", marginRight: 15 }} class="btn btn-outline-secondary" onClick={Book1}>Radar</button>
              <button type="button" style={{ color: "black", fontWeight: "bold", marginRight: 15 }} class="btn btn-outline-secondary" onClick={Book2}>Alerts</button>
              <button type="button" style={{ color: "black", fontWeight: "bold" }} class="btn btn-outline-secondary" onClick={Book3}>Maps</button>

            </div>
          </div>
        </div>
      </nav>

    </div>
  )
}

